
export const DigitalReport = () => {
    return(
        <h1>Digital Report</h1>
    )
};